/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { useState } from "react"
import { Flex, SectionGrid } from "../../components/Layout"
import { BlockText } from "frontend/src/components/BlockText"
import { FiChevronUp, FiChevronDown } from "react-icons/fi"

function FaqQuestion({ question, active, toggleView, index }) {
  const sign = active ? <FiChevronUp /> : <FiChevronDown />
  const QuestionThemeBasic = {
    fontFamily: "heading",
    fontWeight: "medium",
    fontSize: [2, 2, 3],
    lineHeight: 1.45,
    pt: 6,
    // pl: ["23px", "42.6px", "42.6px", "71px"],
    pl: 6,
    color: "#111111",
  }
  const ButtonThemeBasic = {
    ...QuestionThemeBasic,
    backgroundColor: "transparent",
    mr: [7, 8],
    border: "none",
    "&:active": {
      outline: "none",
    },
    "&:focus": {
      outline: "none",
    },
    // pl: ["23px", "42.6px", "42.6px", "71px"],
    pl: 6,
  }
  const QuestionTheme = active
    ? {
        ...QuestionThemeBasic,
        pb: 5,
      }
    : {
        ...QuestionThemeBasic,
        pb: 6,
      }
  const ButtonTheme = active
    ? {
        ...ButtonThemeBasic,
        pb: 5,
      }
    : {
        ...ButtonThemeBasic,
        pb: 6,
      }
  return (
    <Flex
      justify="space-between"
      direction="row"
      align="flex-start"
      onClick={() => toggleView(index)}
    >
      <div sx={QuestionTheme}>{question}</div>
      <button sx={ButtonTheme}>{sign}</button>
    </Flex>
  )
}

function FaqAnswer({ answer, index, current }) {
  return (
    <div
      sx={{
        mb: index === current ? ["24px", "24px", "34px"] : 0,
        // mx: ["23px", "42.6px", "42.6px", "71px"],
        mx: 6,
        pr: ["40px", "88px"],
        transition: "0.2s ease-in",
        maxHeight: index === current ? "100vh" : 0,
        overflow: "hidden",
      }}
    >
      <BlockText
        blocks={answer}
        style={{
          fontFamily: "body",
          fontWeight: "light",
          my: 0,
          fontSize: 1,
          lineHeight: 1.5,
          letterSpacing: "0.24px",
          color: "almostBlack",
          hyphens: ["none", "auto"],
          WebkitHyphens: ["none", "auto"],
          msHyphens: ["none", "auto"],
        }}
        lang="de"
      />
    </div>
  )
}

function FaqSection({ section }) {
  const { title, questions } = section
  const [current, setCurrent] = useState(-1)
  const toggleView = clickedIndex => {
    if (clickedIndex === current) {
      setCurrent(-1)
    } else {
      setCurrent(clickedIndex)
    }
  }
  return (
    <div sx={{ width: "100%" }}>
      <header
        sx={{
          fontFamily: "heading",
          fontWeight: "regular",
          fontSize: [7, 7, 9],
          lineHeight: 1.14,
          letterSpacing: "-1.48px",
          color: "almostBlack",
          mt: 13,
          mb: [7, 7, 8],
          // py: ["22px", "24px", "24px", "40px"],
          // pl: ["23px", "42.6px", "42.6px", "71px"],
          px: 6,
        }}
      >
        {title}
      </header>
      {questions.map((item, index) => (
        <div key={index}>
          <FaqQuestion
            question={item.question}
            toggleView={toggleView}
            active={index === current}
            index={index}
          />
          <FaqAnswer answer={item.answer} index={index} current={current} />
          <div
            sx={{
              height: "0px",
              borderTopWidth: ["0.5px", "0.5px", "0.5px"],
              borderTopColor: "#E5E5E5",
              borderTopStyle: "solid",
              mx: 6,
            }}
          />
        </div>
      ))}
    </div>
  )
}

function Faq({ title, FaqSections }) {
  return (
    <SectionGrid sx={{ mx: "auto", my: "25px" }}>
      <SectionGrid.narrow>
        {FaqSections.map((section, index) => (
          <FaqSection section={section} key={index} />
        ))}
      </SectionGrid.narrow>
    </SectionGrid>
  )
}

export { Faq }
